import { reverse, sortBy, cloneDeep, assign } from 'lodash';
import moment from 'moment';
import { prefixInteger, initVisitor } from '@laigu/utils';

const TRUSTED = {
  NORMAL: 0, // 普通，包括同事，at我，我的等等在机器人托管需求之前的
  TRUSTEESHIP: 1, // 托管专用,
  PRETRUSTEESHIP: 2 // 托管预分配
};

// 默认的展示项
const defaultConvStatus = {
  redirect: false
};
// 时间逆排时 用 4000-01-01的时间戳去减需要对比的时间
// 所以4000年的小伙伴看到这个代码可能需要改一下时间（滑稽）
const staticTimeValue = moment.utc('4000-01-01').valueOf();
const timeLength = `${staticTimeValue}`.length;
const sortList = (convs, keys, { selectedId, markedConvIds } = {}) => {
  // 通过对比字符串实现排序，字符所在位决定条件的优先级
  return sortBy(convs, val => {
    const getImValues = (conv, key) => {
      const getValueMap = {
        // 置顶
        mark: conv => (markedConvIds.includes(conv.id) ? 0 : 1),
        // 无消息的对话
        sinkDown: conv => (conv.client_msg_num === 0 ? 1 : 0),
        // 最新消息时间逆序
        lastMsg: conv => {
          const latestTime = conv.last_msg_created_on || conv.last_updated;
          const lastMsgCreateOn = latestTime ? moment.utc(latestTime).valueOf() : 0;
          return prefixInteger(staticTimeValue - lastMsgCreateOn, timeLength);
        },
        // 对话创建时间顺序
        createOn: conv => {
          const createdOn = conv.created_on ? moment.utc(conv.created_on).valueOf() : 0;
          return prefixInteger(createdOn, timeLength);
        }
      };
      return getValueMap[key](conv);
    };
    return keys.map(key => getImValues(val, key)).join('_');
  });
};

export const getSortConvs = (list = [], { setting, stick, unRead }) => {
  if (!list || list.length === 0) {
    return [];
  }
  const { sortMode: orderRule, sinkDown: isSinkDown } = setting.leftConvSetting;
  switch (orderRule) {
    case 'conv_created_on':
      // 无消息沉底关 置顶 > 对话创建时间
      // 无消息沉底开 置顶 > 无消息沉底 > 对话创建时间
      const convCreatedSortMap = isSinkDown ? ['mark', 'sinkDown', 'createOn'] : ['mark', 'createOn'];
      return sortList(list, convCreatedSortMap, { markedConvIds: stick, unRead });
    case 'new_msg_first':
      // 无消息沉底关 置顶 > 最新消息
      // 无消息沉底开 置顶 > 无消息沉底 > 最新消息
      const msgFirstSortMap = isSinkDown ? ['mark', 'sinkDown', 'lastMsg'] : ['mark', 'lastMsg'];
      return sortList(list, msgFirstSortMap, { markedConvIds: stick, unRead });
    default:
      // 置顶 > 对话创建时间(从最新到最后)
      return sortList(list, ['mark', 'createOn'], { markedConvIds: stick, unRead });
  }
};

export const convWithStatus = ({ conv: convs, convStatus: status, replyTimeout }) => {
  const getStatusById = id => {
    const result = status.find(val => val.convId === id);
    if (result) {
      return { ...defaultConvStatus, ...result };
    }
    return defaultConvStatus;
  };
  return convs.map(conv => {
    return {
      ...conv,
      status: {
        ...getStatusById(conv.id),
        timeout: replyTimeout[conv.id] && replyTimeout[conv.id].status === 'timeout',
        startCountDown: replyTimeout[conv.id] && replyTimeout[conv.id].status === 'startCountDown',
        startTime: (replyTimeout[conv.id] && replyTimeout[conv.id].startTime) || null
      }
    };
  });
};

const addConvType = (item, type) => assign(item, { convType: type });

const addConvsType = (list = [], listType) => {
  return cloneDeep(list).map(val => addConvType(val, listType));
};

export const getMylist = (convs = [], meId) => {
  return convs.filter(
    c => c.agent_id === meId && c.trusted !== TRUSTED.TRUSTEESHIP && c.trusted !== TRUSTED.PRETRUSTEESHIP
  );
};

// export const getRobotPendingConversations = (convs = [], meId) => {
//   return convs.filter(c => c.trusted === TRUSTED.TRUSTEESHIP && c.agent_id === meId);
// };

export const getColleagueList = (convs = [], meId, agentInPermIds) => {
  return convs.filter(
    c =>
      (agentInPermIds.includes(c.agent_id) && c.agent_id !== meId && c.ended_on === null) ||
      c.trusted === TRUSTED.PRETRUSTEESHIP
  );
};

export const getColleaguesWithoutAtLit = (convs = [], meId, agentInPermIds) => {
  return convs.filter(
    c =>
      agentInPermIds.includes(c.agent_id) &&
      c.agent_id !== meId &&
      window.parseInt(c.mentioned_agent_id) !== meId &&
      c.ended_on === null
  );
};

export const getAtMeWithoutMineList = (convs = [], meId) => {
  return convs.filter(
    c => window.parseInt(c.mentioned_agent_id) === meId && c.agent_id !== meId && c.ended_on === null
  );
};
// 筛选当前的对话
export const getChatConversation = (list = [], { listType, meId, agentInPermIds }) => {
  const meConversation = getMylist(list, meId);
  const colleagues = getColleagueList(list, meId, agentInPermIds);
  const colleaguesWithoutAtConversation = getColleaguesWithoutAtLit(list, meId, agentInPermIds);
  const atMeWithoutMineConversation = getAtMeWithoutMineList(list, meId);
  // const robotPendingConversations = getRobotPendingConversations(list, meId);

  let convs = [];
  switch (listType) {
    case 'mine':
      convs = addConvsType(meConversation, 'mine');
      break;
    case 'coll':
      convs = addConvsType(colleagues, 'coll');
      break;
    case 'mention':
      convs = addConvsType(atMeWithoutMineConversation, 'mention');
      break;
    // case 'unrecognized': {
    //   convs = addConvsType(robotPendingConversations, 'unrecognized');
    //   break;
    // }
    case 'all':
      convs = [
        ...addConvsType(meConversation, 'mine'),
        ...addConvsType(colleaguesWithoutAtConversation, 'coll'),
        ...addConvsType(atMeWithoutMineConversation, 'mention')
      ];
      break;
    default:
      convs = [];
  }
  return convs;
};

export const initConvVisitInfo = convs => {
  return convs.map(val => ({
    ...val,
    visit_info: initVisitor(val.visit_info)
  }));
};
